import { createSelector } from 'reselect';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getZeroState } from '../../zero-state/selectors/getZeroState';
import { isChatSetup } from '../../zero-state/operators/getters';
export const getIsChatSetup = createSelector([getCurrentInboxId, getZeroState], (currentInboxId, zeroState) => isChatSetup(currentInboxId, zeroState));